"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosPendingBlendSelectionCreateInputSchema = exports.APosPendingBlendSelectionSchema = exports.APosPendingBlendSelectionCustomBlendPayloadSchema = exports.APosPendingBlendSelectionProductTypeSchema = exports.APosPendingBlendSelectionFulfillmentModeSchema = exports.APosPendingBlendSelectionStatusSchema = exports.APosPendingBlendSelectionSourceSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
/**
 * Module 29 — Oil Blending
 * PendingBlendSelection — short-lived handoff from storefront / kiosk → POS.
 * PK = tenantId, SK = pendingId (psel_{ulid12}). TTL on expires_at attribute (~30 min).
 * GSIs:
 *  - status-location-index ((tenantId#locationId) + status) — POS drawer query
 *  - phone-index (tenantId + phone_number) — match returning customer
 *
 * Status transitions are conditional-update guarded (race-safe between terminals):
 *  open → claimed → completed
 *  open → abandoned | expired
 */
exports.APosPendingBlendSelectionSourceSchema = zod_1.z.enum([
    'kiosk', 'phone', 'store-display',
]);
exports.APosPendingBlendSelectionStatusSchema = zod_1.z.enum([
    'open', 'claimed', 'completed', 'abandoned', 'expired',
]);
exports.APosPendingBlendSelectionFulfillmentModeSchema = zod_1.z.enum([
    'new_bottle', 'refill_own_bottle',
]);
exports.APosPendingBlendSelectionProductTypeSchema = zod_1.z.enum([
    'body_oil', 'essential_oil',
]);
/**
 * Build-your-own draft payload. Schema kept loose (z.unknown()) here because
 * the canonical builder draft shape is owned by the oil-blending-service;
 * shared-types is just the transport contract.
 */
exports.APosPendingBlendSelectionCustomBlendPayloadSchema = zod_1.z.object({
    product_type: exports.APosPendingBlendSelectionProductTypeSchema.optional(),
    bottle_size_ml: zod_1.z.number().positive().optional(),
    total_fragrance_percent: zod_1.z.number().min(0).max(20).optional(),
    carrier_oil_id: id_schema_1.EntityIdSchema.optional(),
    ingredients: zod_1.z.array(zod_1.z.object({
        fragrance_id: id_schema_1.EntityIdSchema,
        percent_of_fragrance_portion: zod_1.z.number().min(0).max(100),
    })).optional(),
    purpose_tags: zod_1.z.array(zod_1.z.string()).optional(),
    mood_tags: zod_1.z.array(zod_1.z.string()).optional(),
    notes: zod_1.z.string().max(2000).optional(),
}).passthrough();
exports.APosPendingBlendSelectionSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    pendingId: id_schema_1.EntityIdSchema.describe('Format: psel_{ulid12}'),
    locationId: id_schema_1.EntityIdSchema.describe('Drives WS channel namespace'),
    source: exports.APosPendingBlendSelectionSourceSchema,
    customer_id: id_schema_1.EntityIdSchema.optional(),
    phone_number: zod_1.z.string().min(1).max(30),
    blend_recipe_id: id_schema_1.EntityIdSchema.optional(),
    custom_blend_payload: exports.APosPendingBlendSelectionCustomBlendPayloadSchema.optional(),
    chosen_bottle_id: id_schema_1.EntityIdSchema.optional(),
    fulfillmentMode: exports.APosPendingBlendSelectionFulfillmentModeSchema,
    customerOwnedBottleId: id_schema_1.EntityIdSchema.optional(),
    chosen_product_type: exports.APosPendingBlendSelectionProductTypeSchema,
    status: exports.APosPendingBlendSelectionStatusSchema.default('open'),
    claimed_by_staff_id: id_schema_1.EntityIdSchema.optional(),
    claimed_at: zod_1.z.number().optional().describe('Unix ms'),
    completed_sale_id: id_schema_1.EntityIdSchema.optional(),
    created_at: zod_1.z.number().describe('Unix ms'),
    expires_at: zod_1.z.number().describe('Unix ms — TTL attribute'),
});
exports.APosPendingBlendSelectionCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    source: exports.APosPendingBlendSelectionSourceSchema,
    customer_id: id_schema_1.EntityIdSchema.optional(),
    phone_number: zod_1.z.string().min(1).max(30),
    blend_recipe_id: id_schema_1.EntityIdSchema.optional(),
    custom_blend_payload: exports.APosPendingBlendSelectionCustomBlendPayloadSchema.optional(),
    chosen_bottle_id: id_schema_1.EntityIdSchema.optional(),
    fulfillmentMode: exports.APosPendingBlendSelectionFulfillmentModeSchema,
    customerOwnedBottleId: id_schema_1.EntityIdSchema.optional(),
    chosen_product_type: exports.APosPendingBlendSelectionProductTypeSchema,
});
//# sourceMappingURL=pending-blend-selection.schema.js.map